import { render, staticRenderFns } from "./AtypicalTransactions.vue?vue&type=template&id=6d0dba70"
import script from "./AtypicalTransactions.vue?vue&type=script&lang=js"
export * from "./AtypicalTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports